/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

export class OpticFiberConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingOpticFiberConfigDimmerActive: false,
      isFiberLowerLimitMaintenanceRequiredProblemChecked: false,
      isFiberLowerLimitUrgentMaintenanceProblemChecked: false,
      isFiberSignalLostProblemChecked: false,
    };
  }

  retrieveData = () => {
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "fiber/tsExpertConfig", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .then(data => this.setState({
          isFiberLowerLimitMaintenanceRequiredProblemChecked: data.isFiberLowerLimitMaintenanceRequiredProblemChecked,
          isFiberLowerLimitUrgentMaintenanceProblemChecked: data.isFiberLowerLimitUrgentMaintenanceProblemChecked,
          isFiberSignalLostProblemChecked: data.isFiberSignalLostProblemChecked,
        }))
        .catch(() => {
          return [];
        })
    } else {
      this.setState({
        isFiberLowerLimitMaintenanceRequiredProblemChecked: false,
        isFiberLowerLimitUrgentMaintenanceProblemChecked: false,
        isFiberSignalLostProblemChecked: false,
      });
    }
  }

  toggleIsFiberLowerLimitMaintenanceRequiredProblemCheckbox = () => {
    this.setState({ isFiberLowerLimitMaintenanceRequiredProblemChecked: !this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked });
  }

  toggleIsFiberLowerLimitUrgentMaintenanceProblemCheckbox = () => {
    this.setState({ isFiberLowerLimitUrgentMaintenanceProblemChecked: !this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked });
  }

  toggleIsFiberSignalLostProblemCheckbox = () => {
    this.setState({ isFiberSignalLostProblemChecked: !this.state.isFiberSignalLostProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertOpticFiberConfiguration = () => {
    this.showSendingOpticFiberConfigDimmer();

    let data = {
      isFiberLowerLimitMaintenanceRequiredProblemChecked: this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked,
      isFiberLowerLimitUrgentMaintenanceProblemChecked: this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked,
      isFiberSignalLostProblemChecked: this.state.isFiberSignalLostProblemChecked,
    };

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "fiber/tsExpertConfig_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
      })
      .finally(this.hideSendingOpticFiberConfigDimmer);
  }

  showSendingOpticFiberConfigDimmer = () => this.setState({ isSendingOpticFiberConfigDimmerActive: true });

  hideSendingOpticFiberConfigDimmer = () => this.setState({ isSendingOpticFiberConfigDimmerActive: false });

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Segment doubling textAlign="left">
        <Header as='h2' textAlign="center" color="teal">
          {Strings.TS_EXPERT_OF}
        </Header>
        <Divider clearing />

        <Segment id="problems-list" style={listSegmentStyle} basic>

          <List divided verticalAlign='middle'>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}</List.Header>
                  {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsFiberLowerLimitMaintenanceRequiredProblemCheckbox}
                    checked={this.state.isFiberLowerLimitMaintenanceRequiredProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}</List.Header>
                  {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsFiberLowerLimitUrgentMaintenanceProblemCheckbox}
                    checked={this.state.isFiberLowerLimitUrgentMaintenanceProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}</List.Header>
                  {Strings.FIBER_SIGNAL_LOSS_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsFiberSignalLostProblemCheckbox}
                    checked={this.state.isFiberSignalLostProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

          </List>

        </Segment>

        <Button
          fluid
          color="teal"
          content={Strings.SAVE}
          onClick={this.saveTsExpertOpticFiberConfiguration} />

        <Dimmer active={this.state.isSendingOpticFiberConfigDimmerActive} >
          <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
        </Dimmer>

      </Segment>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

export default OpticFiberConfig;